import { render, staticRenderFns } from "./flatsTable.vue?vue&type=template&id=0255773a&"
import script from "./flatsTable.vue?vue&type=script&lang=js&"
export * from "./flatsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports